<template>
  <span
    class="ml-1 mb-1 text-purple-ap-100 bg-white text-xs rounded mx-2 uppercase"
  >
    <i class="text-md mr-1 material-icons align-middle text-purple-ap-100">{{
      icon
    }}</i>
    <slot />
  </span>
</template>

<script>
export default {
  name: "Badge",
  props: {
    icon: String,
  },
};
</script>
